<template>
  <div class="warp">
    <header-title :title="title">
      <template #title>
        <span @click="goScanPage(isSignalType)">
          {{ title }}
          <expand-outlined
            :style="{ color: '#eddc1d' }"
            v-show="isSignalType"
          />
        </span>
      </template>
      <template #right>
        <andon-badge
          style="margin-right: 10px"
          :region-code="regionCode"
        ></andon-badge>
        <span @click="init">
          <RedoOutlined />
        </span>
      </template>
    </header-title>
    <a-spin :spinning="loading">
      <div class="warp-body">
        <div class="top-h">
          <div class="nav-main">
            <div class="row">
              <div
                class="col"
                v-for="(item, index) in cols"
                @click="changeTable(item.field, index)"
                :key="index"
                :class="{ active: index == curIndex }"
              >
                <h4>{{ item.name }}</h4>
                <p class="number">
                  {{ item.value }}
                  <span v-if="item.unit" class="unit">{{ item.unit }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="line-area">
            <div class="title">Stock Level</div>
            <div class="water-line">
              <div
                class="line"
                :style="availableLeft"
                :class="{ warning: availableLeftValue >= 100 }"
              >
                <div class="line-point line-point-up point">
                  <span>{{ line.availableStock }}</span>
                  <caretDownOutlined></caretDownOutlined>
                </div>
              </div>
              <div
                class="line-point line-point-down"
                :style="minLeft"
                style="color: saddlebrown"
              >
                <caretUpOutlined></caretUpOutlined>
                <span>{{ line.alertQtyLow }}</span>
              </div>
              <div
                class="line-point line-point-down"
                :style="highLeft"
                style="color: saddlebrown"
              >
                <span>{{ line.alertQtyHigh }}</span>
                <caretUpOutlined></caretUpOutlined>
              </div>
              <div class="line-point line-point-down line-point-right">
                <span>{{ line.alertQtyMax }}</span>
                <caretUpOutlined></caretUpOutlined>
              </div>
            </div>
          </div>
        </div>
        <div class="table-box" ref="aTableRef">
          <a-table
            :columns="columns"
            :row-key="(record) => record.id"
            :data-source="currentDatas"
            :loading="tableLoading"
            :scroll="{ x: isMobile ? 1200 : 'auto', y: tableYHeight }"
            :row-class-name="
              (record, index) => (index % 2 === 1 ? 'table-striped' : null)
            "
            size="small"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.dataIndex === 'subJobId'">
                <span v-if="record.subJobId1">{{ record.subJobId1 }}</span>
                <span v-if="record.subJobId1 && record.subJobId2">,</span>
                <span v-if="record.subJobId2">
                  {{ record.subJobId2 }}
                </span>
              </template>
            </template>
          </a-table>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'
  import AndonBadge from '@/components/andon-badge'
  import {
    ExpandOutlined,
    CaretUpOutlined,
    CaretDownOutlined,
    RedoOutlined,
  } from '@ant-design/icons-vue'
  import { getRegionByGroup } from '@/api/workStation'
  import { getColByRegionCode } from '@/api/staging'
  import { mapGetters } from 'vuex'
  import { STAGING_CONSTANT, colsData } from './const'
  import { throttle } from '@/utils'

  export default {
    components: {
      HeaderTitle,
      AndonBadge,
      ExpandOutlined,
      CaretUpOutlined,
      CaretDownOutlined,
      RedoOutlined,
    },

    data() {
      return {
        regionCode: this.$route.params.regionCode,
        title: 'Staging ' + this.$route.params.regionCode,
        loading: false,
        tableLoading: false,
        isSignalType: false,
        tableYHeight: 300,
        cols: [],
        line: {
          alertQtyLow: 0,
          availableStock: 0,
          alertQtyHigh: 0,
          alertQtyMax: 0,
        },
        currentDatas: [],
        columns: STAGING_CONSTANT.inStageStock,
        curIndex: 0,
        curField: 'inStageStock',
        timer: null,
      }
    },
    created() {
      this.init()
      this.timer = setInterval(() => {
        this.getCols()
        this.getLine()
        this.changeTable(this.curField, this.curIndex)
      }, 30000)
    },
    unmounted() {
      clearInterval(this.timer)
    },
    computed: {
      isMobile() {
        return this.device === 'mobile'
      },
      availableLeftValue() {
        return Math.round(
          (this.line.availableStock * 100) / this.line.alertQtyMax
        ) < 100
          ? Math.round((this.line.availableStock * 100) / this.line.alertQtyMax)
          : 100
      },
      minLeft() {
        return {
          left:
            Math.round((this.line.alertQtyLow * 100) / this.line.alertQtyMax) -
            2 +
            '%',
        }
      },
      highLeft() {
        return {
          left:
            Math.round((this.line.alertQtyHigh * 100) / this.line.alertQtyMax) -
            4 +
            '%',
        }
      },
      availableLeft() {
        return {
          width: this.availableLeftValue + '%',
        }
      },
      ...mapGetters({
        device: 'settings/device',
        curNetGroupId: 'user/currentNetGroup',
      }),
    },
    mounted() {
      this.setTableScrollH()
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      async init() {
        try {
          this.loading = true
          await this.getCols()
          await this.getSignalType()
          await this.getLine()
          const d = await getColByRegionCode(
            'matStageDetailsView',
            this.regionCode
          )
          this.loading = false
          this.currentDatas = d.stagingListView
        } catch (e) {
          this.loading = false
        }
      },
      setTableScrollH() {
        let top = 88
        if (this.$refs.aTableRef) {
          top = this.$refs.aTableRef.getBoundingClientRect().top
        }
        const wH = window.innerHeight
        this.tableYHeight = wH - (top + 150)
      },
      // 判断是否是 signalType ,用来判断是否要到scan页面
      async getSignalType() {
        try {
          const { body } = await getRegionByGroup({
            netGroupId: this.curNetGroupId,
          })
          if (!body.length) return
          const f = body.find((item) => item.regionCode == this.regionCode)
          this.isSignalType = ['RFID', 'BARCODE'].includes(f.signalType)
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },
      goScanPage(isSignalType) {
        if (isSignalType) {
          this.$router.push({
            path: '/scan',
            query: { regionCode: this.regionCode },
          })
        }
      },
      async getCols() {
        try {
          this.cols = colsData
          const regionCode = this.regionCode
          let d = await getColByRegionCode('inStageStock', regionCode)
          this.cols[0].value = d
          let f = await getColByRegionCode('fifoViolation', regionCode)
          this.cols[1].value = f
          let e = await getColByRegionCode('andonAlertStop', regionCode)
          this.cols[2].value = e[1] + '/' + e[0]
          let g = await getColByRegionCode('avgWaitingTime', regionCode)
          this.cols[3].value = g
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },
      async getLine() {
        try {
          const d = await getColByRegionCode('stockLevel', this.regionCode)
          this.line.alertQtyLow = d[0]
          this.line.availableStock = d[1]
          this.line.alertQtyHigh = d[2]
          this.line.alertQtyMax = d[3]
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },
      async changeTable(field, n) {
        this.columns = STAGING_CONSTANT[field]
        this.curField = field
        this.curIndex = n

        const fMap = {
          inStageStock: 'matStageDetailsView',
          fifoViolation: 'fifoVDetailsView',
          alertStop: 'alertStopDetailsView',
          waitingTime: 'avgWaitingTimeDetailsView',
        }
        try {
          this.tableLoading = true
          const d = await getColByRegionCode(fMap[field], this.regionCode)

          this.currentDatas = d.stagingListView

          this.tableLoading = false
        } catch (e) {
          this.tableLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .warp-body {
    height: calc(100vh - 34px - 44px);
    overflow: auto;
  }
  .badge-box {
    position: relative;
    .badge {
      position: absolute;
      top: 0;
      right: -5px;
      width: 18px;
      height: 18px;
      line-height: 18px;
      font-style: normal;
      color: #fff;
      background: @danger;
      text-align: center;
      border-radius: 50%;
    }
  }

  .nav-main {
    background: #eee;
    margin: 0;
    color: #444;
    z-index: 2;
    min-height: 0;
    .row {
      display: flex;
      .col {
        min-height: 0;
        cursor: pointer;
        transition: background 0.2s linear;
        border-right: 1px solid #f4f4f4;
        flex: 1;
        padding: 5px 0;
        position: relative;
        box-shadow: 1px 0 0 rgba(0, 0, 0, 0.1);
        h4 {
          color: #444;
          font-size: 22px;
          text-align: left;
          padding: 0 0 0 15px;
          margin: 0;
        }
        p {
          margin: 0;
          color: #444;
          padding: 0 45px 0 0;
          text-align: right;
          line-height: 40px;
          font-size: 40px;
          font-weight: bold;

          .unit {
            padding-left: 10px;
            font-size: 24px;
          }
        }
        &.active {
          background: #627088;
          color: #dedede;
          border-right-color: #627088;
          h4 {
            color: #dedede;
          }
          p {
            color: #dedede;
          }
        }
      }
    }
  }
  .line-area {
    width: 100%;
    margin-top: 9px;
    margin-bottom: 40px;
    padding: 15px 15px 0;
    height: auto;
    position: relative;
    display: flex;
    justify-content: center;

    .title {
      position: absolute;
      color: #666;
      font-size: 14px;
      left: 15px;
      top: -5px;
    }

    .water-line {
      display: inline-block;
      margin-top: 30px;
      height: 26px;
      width: 100%;
      background: #d4f7ed;
      position: relative;
      box-shadow: 0 0 5px @black1 inset;
      .line {
        height: 26px;
        width: 0;
        position: relative;
        background: #42726a;
        transition: width 1s ease 0.2s;

        &.warning {
          background: #ee4000;
        }
      }

      .line-point {
        width: 60px;
        text-align: right;
        font-size: 22px;
        position: absolute;
        top: -24px;
        color: #42726a;
        line-height: 1;

        span {
          display: inline-block;
          margin-right: 6px;
          vertical-align: top;
        }
        span:last-child {
          margin: 0;
        }

        i {
          vertical-align: top;
          font-size: 36px;
          display: inline-block;
          transform: rotate(90deg);
          -webkit-transform: rotate(90deg);
        }

        &.point {
          i,
          span {
            color: #ffba02;
          }
        }

        &.line-point-down {
          top: 24px;
        }
        &.line-point-up {
          right: -12px;
        }
        &.line-point-up1 {
          right: -9px;
        }
        &.line-point-right {
          right: -7.5px;
          span:last-child {
            margin: 0;
          }
        }
        &.line-point-right1 {
          right: -7.5px;
        }
      }
    }
  }
  .table-box {
    padding: 0 15px;
  }
  :deep(.ant-table-tbody .table-striped td) {
    background-color: #fbfbfb;
  }
  :deep(.r-box) {
    > span {
      width: 40px;
      position: relative;
    }
    > span:active {
      opacity: 0.8;
    }
    > span:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
</style>
